import React from 'react';

import { Grid, Row, Column } from '@xingternal/xing-grid';

import { GridProps, SmallGridProps } from './Types/SmallGridTypes';

import styles from './SmallGrid.css';

const SmallGrid = ({ children, inner, ...props }: SmallGridProps) => {
  const gridProps: GridProps = inner
    ? {
        offset: 0,
        size: 12,
        sizeDesktop: 10,
        offsetDesktop: 1,
        className: styles.gridColumn,
      }
    : {
        offset: 1,
        size: 10,
        className: styles.gridColumn,
      };
  return (
    <Grid type="standard" {...props}>
      <Row className={styles.rowColumn}>
        <Column {...gridProps}>{children}</Column>
      </Row>
    </Grid>
  );
};

export default SmallGrid;
